import React from 'react';
import SEO from '../components/SEO';

const Privacy = () => {
  return (
    <article
      aria-labelledby="privacy-title"
      className="mx-auto w-full max-w-4xl px-6 py-24 font-mono text-xs uppercase leading-loose text-black"
    >
      <SEO
        title="Privacy Policy"
        description="Read the Broadway Muses Privacy Policy to learn how information provided through the website may be collected and used."
        path="/privacy"
      />

      <header className="mb-16 border-b-8 border-black pb-4">
        <h1
          id="privacy-title"
          className="break-words font-serif text-4xl font-black italic md:text-7xl"
        >
          Privacy Policy
        </h1>
      </header>

      <div className="space-y-12">
        <section
          aria-labelledby="privacy-information"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="privacy-information" className="mb-4 text-xl font-bold">
            What Information Do We Collect?
          </h2>
          <p>
            We collect information you provide directly to us, such as when you
            sign up for our newsletter or contact us via email. This may include
            your name and email address.
          </p>
        </section>

        <section
          aria-labelledby="privacy-use"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="privacy-use" className="mb-4 text-xl font-bold">
            How Do We Use Your Information?
          </h2>
          <p>
            We use your information to provide, maintain, and improve our
            services, and to communicate with you about Broadway Muses updates
            and news.
          </p>
        </section>

        <section
          aria-labelledby="privacy-protection"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="privacy-protection" className="mb-4 text-xl font-bold">
            How Do We Protect Your Data?
          </h2>
          <p>
            We take reasonable measures to help protect information about you
            from loss, theft, misuse, and unauthorized access, disclosure,
            alteration, and destruction.
          </p>
        </section>

        <section
          aria-labelledby="privacy-contact"
          className="border-l-4 border-black pl-6"
        >
          <h2 id="privacy-contact" className="mb-4 text-xl font-bold">
            4. Contact Us
          </h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at{' '}
            <a
              href="mailto:broadwaymuses@gmail.com"
              className="underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
            >
              broadwaymuses@gmail.com
            </a>
            .
          </p>
        </section>
      </div>
    </article>
  );
};

export default Privacy;